import PropTypes from "prop-types";
import { CurrentPostContextProvider } from "@circle-react/contexts";
import { MainContent } from "./MainContent";

export const EventViewListItem = ({ post, ...props }) => (
  <CurrentPostContextProvider post={post}>
    <MainContent {...props} />
  </CurrentPostContextProvider>
);

EventViewListItem.propTypes = {
  post: PropTypes.any.isRequired,
};
